import { render, staticRenderFns } from "./settlefrm.vue?vue&type=template&id=50e2b072"
import script from "./settlefrm.vue?vue&type=script&lang=js"
export * from "./settlefrm.vue?vue&type=script&lang=js"
import style0 from "./settlefrm.vue?vue&type=style&index=0&id=50e2b072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports